import { cssVariables } from "@/utils/utils";
import { WarningTwoTone } from "@ant-design/icons";
import { Badge } from "antd";
import { useState } from "react";
import { useInfiniteFilterDashboardNotices } from "../../../../common/api/queries";
import { DashboardNoticePosition } from "../../../dashboard/enums";
import styles from "./CalcNoticesIconView.module.scss";
import { CalcNoticesModal } from "./CalcNoticesModal";

interface Props {
  position: DashboardNoticePosition;
}

export const CalcNoticesIconView = ({ position }: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const { data } = useInfiniteFilterDashboardNotices({ onlyUnclosed: true, position });

  const notices = data?.pages.flatMap((page) => page.pageData);

  return notices?.length ? (
    <>
      <Badge count={notices.length} className={styles.calcNoticeBadge}>
        <WarningTwoTone twoToneColor={cssVariables.colorYellow} onClick={() => setModalOpen(true)} />
      </Badge>

      <CalcNoticesModal open={modalOpen} onCancel={() => setModalOpen(false)} notices={notices} />
    </>
  ) : null;
};
